import { useBreakpoint } from '@twisto/hooks'

import { Icon } from '../icon'

import * as styles from './link-block.styles'

type LinkBlockProps = {
  headline?: string
  text?: string
  url?: string
  icon?: 'InstallmentsFreeIcon' | 'TwistoOutlineIcon' | 'TwistoPayOutlineIcon'
}

export const LinkBlock = ({ headline, text, icon, url }: LinkBlockProps) => {
  const isDesktop = useBreakpoint('smMdUp')

  return (
    <a css={styles.block} href={url}>
      {icon && (
        <div className="icon" css={styles.icon}>
          <Icon name={icon} size="24" />
        </div>
      )}
      <span className="headline" css={styles.headline}>
        {headline}
      </span>
      {isDesktop && (
        <span className="text" css={styles.text}>
          {text}
        </span>
      )}
    </a>
  )
}
